const importance_msg = {
    'Q1.1': {
        'ko': '인권정책에 포함되어 있는 항목',
        'en': 'Items included in human rights policy',
        'ca': '人权政策中包含的项目'
    },
    'Q1.2': {
        'ko': '인권/노동 법규위반 여부',
        'en': 'Human rights/labor law violations',
        'ca': '人权/劳动法规违反情况'
    },
    'Q1.6': {
        'ko': '차별금지규정에 포함되어 있는 항목',
        'en': 'Items included in anti-discrimination regulations',
        'ca': '反歧视规定中包含的项目'
    },
    'Q1.9': {
        'ko': '사업장 내 아동노동 방지 활동',
        'en': 'Child labor prevention activities in the workplace',
        'ca': '工作场所内童工防范活动'
    },
    'Q1.10': {
        'ko': '지원자 채용 비용 부담 여부',
        'en': 'Whether applicants bear recruitment costs',
        'ca': '求职者是否承担招聘费用'
    },
    'Q1.11': {
        'ko': '외국인 근로자 신분증 보유 여부',
        'en': 'Whether foreign workers hold their own identification documents',
        'ca': '外国工人是否持有身份证件'
    },
    'Q1.12': {
        'ko': '직장 내 연장 및 강제노동 방지 활동',
        'en': 'Activities to prevent overtime and forced labor in the workplace',
        'ca': '工作场所内防止加班和强迫劳动的活动'
    },
    'Q1.13': {
        'ko': '근로자 근로조건 보장 여부',
        'en': 'Whether workers\' working conditions are guaranteed',
        'ca': '是否保障工人的工作条件'
    },
    'Q1.14': {
        'ko': '임직원 결사의 자유 보장 및 노동조합(노사협의회) 보유 여부',
        'en': 'Guarantee of employees\' freedom of association and possession of labor unions (labor-management councils)',
        'ca': '保障员工结社自由和拥有工会（劳资协议会）'
    },
    'Q2.1': {
        'ko': '협력사 행동규범 배포/공유 여부',
        'en': 'Whether supplier code of conduct is distributed/shared',
        'ca': '是否发布/共享供应商行为准则'
    },
    'Q2.2': {
        'ko': '협력사 행동규범에 포함되어 있는 항목',
        'en': 'Items included in supplier code of conduct',
        'ca': '供应商行为准则中包含的项目'
    },
    'Q2.3': {
        'ko': '협력사 ESG 리스크 진단 여부',
        'en': 'Whether supplier ESG risk assessment is conducted',
        'ca': '是否进行供应商ESG风险诊断'
    },
    'Q2.6': {
        'ko': '원부자재 조달 정책에 포함되어 있는 항목',
        'en': 'Items included in raw material procurement policy',
        'ca': '原材料采购政策中包含的项目'
    },
    'Q2.8': {
        'ko': '분쟁광물, 책임광물에 대한 리스크 관리 여부',
        'en': 'Whether risk management for conflict minerals and responsible minerals is in place',
        'ca': '是否进行冲突矿产和负责任矿产的风险管理'
    },
    'Q3.1': {
        'ko': '윤리정책에 포함되어 있는 항목',
        'en': 'Items included in ethics policy',
        'ca': '道德政策中包含的项目'
    },
    'Q3.2': {
        'ko': '윤리법규 위반 여부',
        'en': 'Ethics law violations',
        'ca': '道德法规违反情况'
    },
    'Q3.4': {
        'ko': '반부패 관련 윤리경영 활동',
        'en': 'Anti-corruption related ethical management activities',
        'ca': '反腐败相关道德经营活动'
    },
    'Q3.5': {
        'ko': '내외부 이해관계자 위한 고충채널 보유',
        'en': 'Possession of grievance channels for internal and external stakeholders',
        'ca': '为内外部利益相关者设置的申诉渠道'
    },
    'Q3.7': {
        'ko': '정보보안을 위한 활동',
        'en': 'Information security activities',
        'ca': '信息安全相关活动'
    },
    'Q4.1': {
        'ko': '사업장 안전정책 보유 여부',
        'en': 'Whether workplace safety policy is in place',
        'ca': '是否拥有工作场所安全政策'
    },
    'Q4.2': {
        'ko': '안전법규 위반 여부',
        'en': 'Safety law violations',
        'ca': '安全法规违反情况'
    },
    'Q4.3': {
        'ko': '임직원 안전 및 건강을 위한 활동',
        'en': 'Activities for employee safety and health',
        'ca': '员工安全和健康相关活动'
    },
    'Q4.4': {
        'ko': '사업장 산업재해 방지 활동',
        'en': 'Workplace industrial accident prevention activities',
        'ca': '工作场所工业事故防范活动'
    },
    'Q4.5': {
        'ko': '근로손실재해율 관리 여부',
        'en': 'Whether lost-time injury rate is managed',
        'ca': '是否管理工伤损失率'
    },
    'Q4.7': {
        'ko': '기숙시설 관리 활동',
        'en': 'Dormitory facility management activities',
        'ca': '宿舍设施管理活动'
    },
    'Q4.8': {
        'ko': '식당시설 관리 활동',
        'en': 'Cafeteria facility management activities',
        'ca': '食堂设施管理活动'
    },
    'Q5.1': {
        'ko': '환경정책에 포함되어 있는 항목',
        'en': 'Items included in environmental policy',
        'ca': '环境政策中包含的项目'
    },
    'Q5.2': {
        'ko': '환경법규 위반 여부',
        'en': 'Environmental law violations',
        'ca': '环境法规违反情况'
    },
    'Q5.4': {
        'ko': '환경지표별 KPI 수립 여부',
        'en': 'Whether KPIs are established for environmental indicators',
        'ca': '是否制定环境指标KPI'
    },
    'Q6.2': {
        'ko': '온실가스 배출 모니터링 활동',
        'en': 'Greenhouse gas emission monitoring activities',
        'ca': '温室气体排放监测活动'
    },
    'Q6.5': {
        'ko': 'Scope1 배출량 관리',
        'en': 'Scope 1 emissions management',
        'ca': '范围1排放量管理'
    },
    'Q6.6': {
        'ko': 'Scope2 배출량 관리',
        'en': 'Scope 2 emissions management',
        'ca': '范围2排放量管理'
    },
    'Q6.8': {
        'ko': '에너지 소비량 관리',
        'en': 'Energy consumption management',
        'ca': '能源消耗量管理'
    },
    'Q7.7': {
        'ko': '유해화학물질 관리',
        'en': 'Hazardous chemical substance management',
        'ca': '有害化学物质管理'
    },
    'Q7.9': {
        'ko': '대기오염물질 관리 규정 보유',
        'en': 'Possession of air pollutant management regulations',
        'ca': '拥有大气污染物管理规定'
    },
    'Q7.12': {
        'ko': 'NOx배출량 관리',
        'en': 'NOx emission management',
        'ca': '氮氧化物排放量管理'
    },
    'Q7.13': {
        'ko': 'Sox배출량 관리',
        'en': 'SOx emission management',
        'ca': '硫氧化物排放量管理'
    },
    'Q7.14': {
        'ko': 'PM배출량 관리',
        'en': 'PM emission management',
        'ca': '颗粒物排放量管理'
    },
    'Q8.1': {
        'ko': '용수/폐수 관리규정 보유',
        'en': 'Possession of water/wastewater management regulations',
        'ca': '拥有用水/废水管理规定'
    },
    'Q8.3': {
        'ko': '용수취수량 관리',
        'en': 'Water intake management',
        'ca': '用水取水量管理'
    },
    'Q8.4': {
        'ko': '폐수배출 관리',
        'en': 'Water intake management',
        'ca': '用水取水量管理'
    },
    'Q8.5': {
        'ko': '폐수배출량 관리',
        'en': 'Wastewater discharge management',
        'ca': '废水排放量管理'
    },
    'Q8.6': {
        'ko': 'BOD관리',
        'en': 'BOD management',
        'ca': 'BOD管理'
    },
    'Q8.7': {
        'ko': 'COD관리',
        'en': 'COD management',
        'ca': 'COD管理'
    },
    'Q9.1': {
        'ko': '생물다양성 평가수행',
        'en': 'Biodiversity assessment implementation',
        'ca': '实施生物多样性评估'
    },
    'Q9.4': {
        'ko': '동식물 수출입규정 보유',
        'en': 'Possession of flora and fauna import/export regulations',
        'ca': '拥有动植物进出口规定'
    },
    'Q9.5': {
        'ko': '유전자원 활용규정 보유',
        'en': 'Possession of genetic resource utilization regulations',
        'ca': '拥有遗传资源利用规定'
    },
    'Q10.1': {
        'ko': '폐기물관리 규정보유',
        'en': 'Possession of waste management regulations',
        'ca': '拥有废物管理规定'
    },
    'Q10.3': {
        'ko': '일반폐기물 발생량관리',
        'en': 'General waste generation management',
        'ca': '一般废物发生量管理'
    },
    'Q10.5': {
        'ko': '유해폐기물 발생량관리',
        'en': 'Hazardous waste generation management',
        'ca': '有害废物发生量管理'
    },
    'Q10.6': {
        'ko': '폐기물 재사용량 관리',
        'en': 'Waste reuse amount management',
        'ca': '废物再利用量管理'
    }
};

const category3_order = {
    // 일반 질문지
    'q5939300673': {
        'category3_question_name': '인권공통',
        'category3_question_code': 'q5939300673',
        'order': 28
    },
    'q3561726261': {
        'category3_question_name': '차별금지',
        'category3_question_code': 'q3561726261',
        'order': 29
    },
    'q228745889': {
        'category3_question_name': '보안업체 관리',
        'category3_question_code': 'q228745889',
        'order': 30
    },
    'q1656635059': {
        'category3_question_name': '아동노동',
        'category3_question_code': 'q1656635059',
        'order': 31
    },
    'q2386763468': {
        'category3_question_name': '강제노동',
        'category3_question_code': 'q2386763468',
        'order': 32
    },
    'q776155016': {
        'category3_question_name': '근로조건',
        'category3_question_code': 'q776155016',
        'order': 33
    },
    'q8227268440': {
        'category3_question_name': '결사의 자유',
        'category3_question_code': 'q8227268440',
        'order': 34
    },
    'q9197169738': {
        'category3_question_name': '지역사회',
        'category3_question_code': 'q9197169738',
        'order': 35
    },
    'q1455991401': {
        'category3_question_name': '생활임금',
        'category3_question_code': 'q1455991401',
        'order': 36
    },
    'q140835840': {
        'category3_question_name': '공급망 관리',
        'category3_question_code': 'q140835840',
        'order': 37
    },
    'q9608651': {
        'category3_question_name': '원자재 조달',
        'category3_question_code': 'q9608651',
        'order': 38
    },
    'q240034787': {
        'category3_question_name': '윤리공통',
        'category3_question_code': 'q240034787',
        'order': 39
    },
    'q315047666': {
        'category3_question_name': '반부패',
        'category3_question_code': 'q315047666',
        'order': 40
    },
    'q355581348': {
        'category3_question_name': '정보보안',
        'category3_question_code': 'q355581348',
        'order': 41
    },
    'q4767335300': {
        'category3_question_name': '안전/보건',
        'category3_question_code': 'q4767335300',
        'order': 42
    },
    'q7558906817': {
        'category3_question_name': '적절한 주거',
        'category3_question_code': 'q7558906817',
        'order': 43
    },
    'q4994218071': {
        'category3_question_name': '환경경영 일반',
        'category3_question_code': 'q4994218071',
        'order': 44
    },
    'q814519563': {
        'category3_question_name': '기후변화 공통',
        'category3_question_code': 'q814519563',
        'order': 45
    },
    'q891127585': {
        'category3_question_name': '온실가스',
        'category3_question_code': 'q891127585',
        'order': 46
    },
    'q824915158': {
        'category3_question_name': '에너지',
        'category3_question_code': 'q824915158',
        'order': 47
    },
    'q348001149': {
        'category3_question_name': '수은 및 수은 화합물 관리',
        'category3_question_code': 'q348001149',
        'order': 48
    },
    'q522169839': {
        'category3_question_name': '잔류성유기 오염물질 관리',
        'category3_question_code': 'q522169839',
        'order': 49
    },
    'q124552929': {
        'category3_question_name': '오존층 파괴물질 관리',
        'category3_question_code': 'q124552929',
        'order': 50
    },
    'q272861039': {
        'category3_question_name': '화학물질 관리',
        'category3_question_code': 'q272861039',
        'order': 51
    },
    'q862575877': {
        'category3_question_name': '대기오염 물질',
        'category3_question_code': 'q862575877',
        'order': 52
    },
    'q813181211': {
        'category3_question_name': '해양오염 방지',
        'category3_question_code': 'q813181211',
        'order': 53
    },
    'q244620398': {
        'category3_question_name': '수자원 관리',
        'category3_question_code': 'q244620398',
        'order': 54
    },
    'q729645895': {
        'category3_question_name': '생물다양성',
        'category3_question_code': 'q729645895',
        'order': 55
    },
    'q72515248': {
        'category3_question_name': '멸종위기  동식물종  보전',
        'category3_question_code': 'q72515248',
        'order': 56
    },
    'q827123119': {
        'category3_question_name': '유전자원',
        'category3_question_code': 'q827123119',
        'order': 57
    },
    'q183037566': {
        'category3_question_name': '폐기물',
        'category3_question_code': 'q183037566',
        'order': 58
    },
    // HMMA
    'q9321591426': {
        'category3_question_name': '인권공통',
        'category3_question_code': 'q9321591426',
        'order': 28
    },
    'q3865438171': {
        'category3_question_name': '차별금지',
        'category3_question_code': 'q3865438171',
        'order': 29
    },
    'q1701707429': {
        'category3_question_name': '보안업체 관리',
        'category3_question_code': 'q1701707429',
        'order': 30
    },
    'q9983772891': {
        'category3_question_name': '아동노동',
        'category3_question_code': 'q9983772891',
        'order': 31
    },
    'q753488276': {
        'category3_question_name': '강제노동',
        'category3_question_code': 'q753488276',
        'order': 32
    },
    'q3242600857': {
        'category3_question_name': '근로조건',
        'category3_question_code': 'q3242600857',
        'order': 33
    },
    'q4431740274': {
        'category3_question_name': '결사의 자유',
        'category3_question_code': 'q4431740274',
        'order': 34
    },
    'q903988132': {
        'category3_question_name': '지역사회',
        'category3_question_code': 'q903988132',
        'order': 35
    },
    'q3188296816': {
        'category3_question_name': '생활임금',
        'category3_question_code': 'q3188296816',
        'order': 36
    },
    'q7884576988': {
        'category3_question_name': '공급망 관리',
        'category3_question_code': 'q7884576988',
        'order': 37
    },
    'q4856419433': {
        'category3_question_name': '원자재 조달',
        'category3_question_code': 'q4856419433',
        'order': 38
    },
    'q2390543859': {
        'category3_question_name': '윤리공통',
        'category3_question_code': 'q2390543859',
        'order': 39
    },
    'q7652310740': {
        'category3_question_name': '반부패',
        'category3_question_code': 'q7652310740',
        'order': 40
    },
    'q2874434847': {
        'category3_question_name': '정보보안',
        'category3_question_code': 'q2874434847',
        'order': 41
    },
    'q8463687090': {
        'category3_question_name': '안전/보건',
        'category3_question_code': 'q8463687090',
        'order': 42
    },
    'q4091544121': {
        'category3_question_name': '적절한 주거',
        'category3_question_code': 'q4091544121',
        'order': 43
    },
    'q1122283547': {
        'category3_question_name': '환경경영 일반',
        'category3_question_code': 'q1122283547',
        'order': 44
    },
    'q4617679129': {
        'category3_question_name': '기후변화 공통',
        'category3_question_code': 'q4617679129',
        'order': 45
    },
    'q1841694440': {
        'category3_question_name': '온실가스',
        'category3_question_code': 'q1841694440',
        'order': 46
    },
    'q2662265436': {
        'category3_question_name': '에너지',
        'category3_question_code': 'q2662265436',
        'order': 47
    },
    'q3007896123': {
        'category3_question_name': '수은 및 수은 화합물 관리',
        'category3_question_code': 'q3007896123',
        'order': 48
    },
    'q7516432745': {
        'category3_question_name': '잔류성유기 오염물질 관리',
        'category3_question_code': 'q7516432745',
        'order': 49
    },
    'q3524418879': {
        'category3_question_name': '오존층 파괴물질 관리',
        'category3_question_code': 'q3524418879',
        'order': 50
    },
    'q7271255405': {
        'category3_question_name': '화학물질 관리',
        'category3_question_code': 'q7271255405',
        'order': 51
    },
    'q4493785589': {
        'category3_question_name': '대기오염 물질',
        'category3_question_code': 'q4493785589',
        'order': 52
    },
    'q8432651901': {
        'category3_question_name': '해양오염 방지',
        'category3_question_code': 'q8432651901',
        'order': 53
    },
    'q3698625537': {
        'category3_question_name': '수자원 관리',
        'category3_question_code': 'q3698625537',
        'order': 54
    },
    'q3185363825': {
        'category3_question_name': '생물다양성',
        'category3_question_code': 'q3185363825',
        'order': 55
    },
    'q1531965919': {
        'category3_question_name': '멸종위기  동식물종  보전',
        'category3_question_code': 'q1531965919',
        'order': 56
    },
    'q524374823': {
        'category3_question_name': '유전자원',
        'category3_question_code': 'q524374823',
        'order': 57
    },
    'q5188704349': {
        'category3_question_name': '폐기물',
        'category3_question_code': 'q5188704349',
        'order': 58
    }
};


const getStateColor = (score) => {
    const parsedScore = Number(score);
    
    if (score === null || isNaN(parsedScore)) {
        return '#969696';
    }
    
    if (parsedScore === 100) {
        return '#2aad50';
    } else if (parsedScore >= 75) {
        return '#86c83b';
    } else if (parsedScore >= 50) {
        return '#c9db00';
    } else if (parsedScore >= 25) {
        return '#ff5721';
    } else { // 25점 미만 (0 포함)
        return '#dc353c';
    }
};
const getScore = (score) => {
    if (score == null) return '-';
    return Number((Math.round(score * 10) / 10).toFixed(1));
};
export { importance_msg, getStateColor, getScore,category3_order};

